module.exports = __webpack_public_path__ + "fonts/PT_Sans-CaptionRegular.3fdefd40.eot";